import {IVanillaReaderUI} from './IVanillaReaderUI';
import {IVanillaReaderUiComponentController} from './IVanillaReaderUiComponentController';
import {VanillaReaderUI} from './VanillaReaderUI';

export interface VanillaReaderUiPanZoomToolController extends IVanillaReaderUiComponentController, IVanillaReaderUI {
}

/**
 * # VanillaReaderUiPanZoomToolController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all events and callbacks from `VanillaReaderUiPanZoomTool`.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUiPanZoomTool
 *
 */
export class VanillaReaderUiPanZoomToolController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.panZoomTool.onActivate(vanillaReaderUiContext._onPanZoomStateActivateIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDeactivate(vanillaReaderUiContext._onPanZoomStateDeactivateIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onZoomReset(vanillaReaderUiContext._onZoomLevelResetIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDragStart(vanillaReaderUiContext._onZoomToolDragStart.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDrag(vanillaReaderUiContext._onZoomToolDrag.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onDragEnd(vanillaReaderUiContext._onZoomToolDragEnd.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onPanningEnable(vanillaReaderUiContext._onPanningEnableIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onPanningDisable(vanillaReaderUiContext._onPanningDisableIntent.bind(vanillaReaderUiContext));
        vanillaReaderUiContext.panZoomTool.onZoomToLevel(vanillaReaderUiContext._onZoomToLevel.bind(vanillaReaderUiContext));

    }

    _onPanZoomStateActivateIntent(): void {
        if (!this.isMobileScreenSize) {
            this.menuBottom.togglePanZoomButtonState(true);
        }
    }

    _onPanZoomStateDeactivateIntent(): void {
        this.panZoomTool.resetZoomToolRect();

        if (!this.isMobileScreenSize) {
            this.menuBottom.togglePanZoomButtonState(false);
        }

        this.vanillaReaderAPI?.resetZoom();
    }

    _onZoomLevelResetIntent(): void {
        this.vanillaReaderAPI?.zoomToLevel(1, !this.useReducedMotion);
    }

    _onPanningEnableIntent(): void {
        this.vanillaReaderAPI?.activatePanZoomMode();
    }

    _onPanningDisableIntent(): void {
        this.vanillaReaderAPI?.deactivatePanZoomMode();
    }

    _onZoomToLevel(zoomLevel: number): void {
        this.vanillaReaderAPI?.zoomToLevel(zoomLevel, !this.useReducedMotion);
    }

    _onZoomToolDragStart(): void {
    }

    _onZoomToolDrag(): void {
    }

    _onZoomToolDragEnd(_ev: PointerEvent, zoomRect: DOMRect | undefined): void {
        this.panZoomTool.disablePointerZoom();
        this.panZoomTool.resetZoomToolRect();
        if (zoomRect) {
            this.vanillaReaderAPI?.zoomToClientRect(zoomRect, !this.useReducedMotion).catch(console.warn);
        }
    }
}
